import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getHelloMessage, getInfo } from '../api';

function Home() {
  const [helloMessage, setHelloMessage] = useState('');
  const [info, setInfo] = useState('');

  useEffect(() => {
    // Fetch hello message and info when component mounts
    fetchHelloMessage();
    fetchInfo();
  }, []);

  const fetchHelloMessage = async () => {
    const message = await getHelloMessage();
    setHelloMessage(message);
  };

  const fetchInfo = async () => {
    const info = await getInfo();
    setInfo(info);
  };

  return (
    <div className="container mx-auto p-4">
      <div className="card bg-base-200 shadow-xl my-4">
        <div className="card-body">
          <h1 className="card-title text-2xl">Welcome to the App</h1>
          <h2 className="text-xl">Protected Content</h2>
          
          <div className="divider"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="card bg-base-300 shadow-md p-4">
              <h3 className="font-bold mb-2">Features</h3>
              <ul className="list-disc list-inside">
                <li className="mb-2">
                  <Link to="/chat" className="link link-primary">
                    Real-time Chat
                  </Link>
                  <p className="text-sm opacity-75">
                    Communicate with other users in real-time
                  </p>
                </li>
                <li className="mb-2">
                  <Link to="/profile" className="link link-primary">
                    Profile Management
                  </Link>
                  <p className="text-sm opacity-75">
                    Customize your profile information
                  </p>
                </li>
                <li className="mb-2">
                  <Link to="/subscribe" className="link link-primary">
                    Subscription Plans
                  </Link>
                  <p className="text-sm opacity-75">
                    Choose a plan that fits your needs
                  </p>
                </li>
              </ul>
            </div>
            
            <div className="card bg-base-300 shadow-md p-4">
              <h3 className="font-bold mb-2">API Information</h3>
              <div className="mb-4">
                <h4 className="font-bold">Hello Message:</h4>
                <p className="py-2">{helloMessage}</p>
                <button className="btn btn-primary btn-sm mt-2" onClick={fetchHelloMessage}>Refresh Hello Message</button>
              </div>

              <div>
                <h4 className="font-bold">API Info:</h4>
                <pre className="py-2 overflow-x-auto bg-base-100 p-2 rounded">
                  {typeof info === 'object' ? JSON.stringify(info, null, 2) : info}
                </pre>
                <button className="btn btn-primary btn-sm mt-2" onClick={fetchInfo}>Refresh Info</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
